<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #beforeDropdown>
        <b-button variant="success" class="btn-icon" v-b-tooltip v-bind:title="$t('operations.add')"
                  v-if="hasPermission(permissions.PSP_MANAGE)"
                  @click="onPspSelected(null)"
        >
          <i class="fa-solid fa-plus"></i>
        </b-button>
      </template>
    </breadcrumb-button>
    <!--Filters-->
    <filter-card v-model="filter" v-bind:fields="filterFields" search/>
    <!--Table Card-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{ $t('menu.psps') }}</h5>
      </b-card-header>
      <b-card-body>
        <psp-table ref="pspTable" v-bind:filters="filter"
                   @selected="onPspSelected" :lazy="true"/>
      </b-card-body>
    </b-card>
    <!--Modal-->
    <psp-modal ref="psp-modal" @submitted="onSubmitted"/>
  </div>
</template>

<script>

import BreadcrumbButton from '@/components/widget/breadcrumbButton';
import mixinPermissions from '@/components/mixin/mixinPermissions';
import mixinBase from '@/components/mixin/mixinBase';
import FilterCard from '@/components/widget/FilterCard';
import PspSearchRequest from '@/model/psp/PspSearchRequest';
import PspFilterFields from '@/model/filter/PspFilterFields';
import PspTable from '@/components/tables/PspTable';
import PspModal from '@/components/modal/pspModal';

export default {
  name: 'PspView',
  components: {
    PspTable,
    PspModal,
    FilterCard,
    BreadcrumbButton,
  },
  mixins: [mixinBase, mixinPermissions],
  data() {
    return {
      filter: PspSearchRequest(),
      filterFields: null,
    };
  },
  created() {
    this.filterFields = PspFilterFields();
  },
  methods: {
    onPspSelected(selectedId) {
      this.$refs['psp-modal'].showModal(selectedId);
    },
    onSubmitted() {
      this.$refs['pspTable'].refresh();
    },
  }
};
</script>

<style scoped>

</style>
